<template lang="pug">
.report 
  WebTemplate(
    pagetitle= "搜索推广",
    tip= "搜索推广报告为您展示360搜索推广的推广及效果数据，帮助您及时了解您网站在360上的搜索推广状态，依据效果数据优化账户",
    timeType="7a",
    :currentTab= "currentTab",
    :total= "total",
    :pg= "pg",
    :ps= "ps",
    :tablist= "tablist",
    :customColumns = "customColumns",
    :tableDataList= "tableDataList",
    :hasCheckBox= "hasCheckBox",
    :checkboxLength= "checkboxLength",
    :sum= "sum",
    :order= "order",
    :legend= "legend", 
    :yAxis="yAxis",
    :chartXAxis= "chartXAxis",
    :chartSeries= "chartSeries",
    @indiceChange= "indiceChange",
    @tableUpdate= "getTableData",
    @tablesorter= "tablesorter",
    :customIndice= "customIndice",
    :twoIndiceShow= "twoIndiceShow",
    :twoIndice= "twoIndice")
    span.floatr(v-if="dianjingIDList.length > 0" slot="accountSelect")
      label 账号切换：
      v-select(
        v-model="dianjingID",
        :options="dianjingIDList",
        @input="resetCompared")
    i.mv-tips(v-show="mvDemain" slot="tableTitleTip") 为什么看不到流量及转化数据
        v-tooltip(
          :tip="'由于您网站添加的代码为聚合分析代码，无法获取搜索推广对应的流量数据，若您想查看该部分数据，建议为您的网站重新添加360分析代码。'",
          pos="right")
          i.fa.fa-question-circle

    ul.tab(slot="tabview")
      li.tab-item(v-for="item in tabViews")
        .tabview-btn(
                @click.prevent="changeViewTo(item.comp)",
                :class="{ active: currentView === item.comp}"
              ) {{item.title}}
    div.nav-tabs(slot="nav-tabs")
      TabContent(
        title="主维度：",
        :tablist="tablist",
        :update="updateTab",
        :currentTab="currentTab")
        div.right-tab(slot="extentTab")
          DownloadBtn(
            :reportApi="reportApi",
            :params="query",
            :pagetitle="reportName",
            subtitle="",
            v-if="total > 0",
            style="float: right;")
          CustomIndice(
            :defaults="defaultCustomIndices",
            :hasSystemIndice="true",
            :hasSpreadIndice="true",
            :fluxExtend= "fluxExtend",
            @change="onCustomIndiceChange")
        div(slot="common") 
          p.plan-nav(v-show="sdimOptionShow")
            | 选择二级维度：
            v-radio-group(
              v-model="sdim",
              name="secondaryDim",
              :options="sdimOptions",
              @change.native="sdimChange")
          p.tabAction
            button.btn.btn-primary.btn-big(
              :disabled="fetchLineChartabled",
              @click="fetchLineChartData") 绘制选定行
            v-select(
              v-model="planselected",
              @input="getGroupList",
              :options="planlistOptions",
              v-if="planlistShow")
            v-select(
              v-model="groupselected",
              @input="getTableData(1)",
              :options="grouplistOptions",
              v-if="grouplistShow && planselected")
            Search(
              v-show="searchBoxShow",
              :placeholder="placeHolder",
              @doSearch="doSearch",
              :defaultValue="keyword")
    v-select(
      slot="custom",
      v-if="transTypeShow",
      v-model="transelected",
      :options="transList",
      @input="getTableData()"
      )
    v-tooltip(slot="adpv-th",
        v-show="currentView != 'promotion'",
        :tip="'搜索词报告展现量统计过滤了展现极低且无点击数据，请使用此报告主要进行触发分析，实际数据以效果分析报告为准。'",
        pos="right")
        i.fa.fa-question-circle(style="margin-left: 5px;")
</template>

<script>
  /* global _ */
  import Store from '../../store/store.js'
  import Mixin from '../mixin.js'
  import WebTemplate from './template'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    store: Store,
    components: {
      WebTemplate
    },
    mixins: [Mixin],
    data () {
      return {
        chartResList: [],
        hasCheckBox: false,
        checkboxLength: 3,
        total: 0,
        pg: 1,
        ps: 10,
        planselected: 0,
        planlistOptions: [{value: 0, label: '全部推广计划'}],
        groupselected: 0,
        grouplistOptions: [{value: 0, label: '全部推广组'}],
        sdim: 'null',
        currentTab: 'product',
        isasc: 0,
        order: 'date',
        legend: [],
        currentView: 'promotion',
        tabViews: [
          {
            comp: 'promotion',
            title: '效果分析',
            tablist: [
              {
                id: 'product',
                name: '推广趋势',
                order: 'date',
                reportTableApi: '/api/report/adProduct?groupby=date,product',
                basicSummaryStatApi: '/api/report/adProduct?groupby=product&issum=1',
                reportLineChartApi: '/api/report/adProduct?groupby=date,product'
              },
              {
                id: 'planId',
                name: '推广计划',
                order: 'adpv',
                reportTableApi: '/api/report/djadPlan?groupby=plan',
                basicSummaryStatApi: '/api/report/djadPlan?issum=1&groupby=plan&isasc=0',
                reportLineChartApi: '/api/report/djadPlan?groupby=plan,date'
              },
              {
                id: 'groupName__plan',
                name: '推广组',
                order: 'adpv',
                reportTableApi: '/api/report/djadGroup?groupby=group',
                basicSummaryStatApi: '/api/report/djadGroup?groupby=group&issum=1',
                reportLineChartApi: '/api/report/djadGroup?groupby=date,group'
              },
              {
                id: 'keyword',
                name: '关键词',
                order: 'adpv',
                reportTableApi: '/api/report/djadKeyword?groupby=keyword',
                basicSummaryStatApi: '/api/report/djadKeyword?groupby=keyword&issum=1',
                reportLineChartApi: '/api/report/djadKeyword?groupby=date,keyword'
              },
              {
                id: 'advert__plan__groupName',
                name: '创意',
                order: 'adpv',
                reportTableApi: '/api/report/djadAdvert?&groupby=advert',
                basicSummaryStatApi: '/api/report/djadAdvert?&issum=1&groupby=advert',
                reportLineChartApi: '/api/report/djadAdvert?groupby=advert,date'
              },
              {
                id: 'province',
                name: '地域',
                order: 'adpv',
                reportTableApi: '/api/report/djadProvince?isasc=0&order=adpv&groupby=province',
                basicSummaryStatApi: '/api/report/djadProvince?isasc=0&order=adpv&groupby=province&issum=1',
                reportLineChartApi: '/api/report/djadProvince?isasc=0&order=adpv&groupby=date,province'
              }
            ]
          }, {
            comp: 'query',
            title: '搜索词报告',
            tablist: [
              {
                id: 'query__keyword__matchtype',
                name: '搜索词',
                order: 'adpv',
                reportTableApi: '/api/report/keywordreport?groupby=query',
                basicSummaryStatApi: '/api/report/keywordreport?groupby=query&issum=1',
                reportLineChartApi: '/api/report/keywordreport?groupby=query,date'
              }
            ]
          }, {
            comp: 'landpage',
            title: '落地页分析',
            tablist: [
              {
                id: 'landpage__keyword',
                name: '落地页',
                order: 'adpv',
                reportTableApi: '/api/report/landpage?groupby=landpage',
                basicSummaryStatApi: '/api/report/landpage?groupby=landpage&issum=1',
                reportLineChartApi: '/api/report/landpage?groupby=landpage,date'
              }
            ]
          }
        ],
        chartXAxis: [],
        chartSeries: [],
        yAxis: [],
        customIndice: 'adpv',
        twoIndice: '',
        twoIndiceShow: true,
        sum: {},
        keyword: '',
        tableDataList: [],
        fluxExtend: {'reachrate': '到达率'},
        defaultCustomIndices: ['adpv', 'adclick', 'adctr', 'adcost', 'adcpc', 'adcpm', 'pv', 'vnum', 'reachrate', 'atime', 'tnum'],
        sdimOptions: [],
        mvDemain: false,
        dianjingID: 0,
        dianjingIDList: [],
        transelected: 'null',
        transList: [
          {
            label: '全部转化',
            value: 'null'
          }
        ]
      }
    },
    computed: {
      ...mapState('web', {
        tableIndices: state => state.tableIndices,
        compared: state => state.compared,
        compareStart: state => state.compareStart,
        compareEnd: state => state.compareEnd
      }),
      ...mapGetters('web', [
        'indicesMenu',
        'domainId',
        'uiError',
        'fetchLineChartabled',
        'twoIndiceSelectabled'
      ]),
      sdimOptionShow () {
        return this.currentTab === 'planId'
      },
      transTypeShow () {
        return this.currentView !== 'externalLink'
      },
      tablist () {
        return _.find(this.tabViews, {comp: this.currentView}).tablist
      },
      searchBoxShow () {
        return this.currentTab !== 'product'
      },
      planlistShow () {
        return this.currentTab === 'groupName__plan' || this.currentTab === 'keyword' || this.currentTab === 'advert__plan__groupName' || this.currentTab === 'query__keyword__matchtype' || this.currentTab === 'landpage__keyword'
      },
      grouplistShow () {
        return this.currentTab === 'keyword' || this.currentTab === 'advert__plan__groupName' || this.currentTab === 'query__keyword__matchtype' || this.currentTab === 'landpage__keyword'
      },
      query () {
        let query = {
          isasc: this.isasc,
          order: this.order,
          domainId: this.domainId,
          pvtype: 0,
          start: this.$store.state.start,
          end: this.$store.state.end,
          cycle: this.$store.state.start === this.$store.state.end ? 'hour' : 'day',
          timespan: new Date().getTime(),
          djid: this.dianjingID,
          mdim: this.currentTab
        }
        if (this.sdim !== 'null') {
          query = _.assignIn({
            sdim: this.sdim
          }, query)
        }
        if (this.compared) {
          query = _.assignIn({
            compareStart: this.compareStart,
            compareEnd: this.compareEnd
          }, query)
        }
        if (this.transelected !== 'null') {
          query = _.assignIn({
            tids: this.transelected
          }, query)
        }
        if (this.keyword) {
          const keyword = {}
          switch (this.currentTab) {
            case 'product':
              keyword.product = this.keyword
              break
            case 'planId':
              keyword.plan = this.keyword
              break
            case 'province':
              keyword.province = this.keyword
              break
            case 'groupName__plan':
              keyword.group = this.keyword
              break
            case 'keyword':
              keyword.keyword = this.keyword
              break
            case 'advert__plan__groupName':
              keyword.advert = this.keyword
              break
            case 'query__keyword__matchtype':
              keyword.keyword = this.keyword
              break
            case 'landpage__keyword':
              keyword.landpage = this.keyword
              break
            default:
              break
          }
          query = _.assignIn({}, keyword, query)
        }
        // planselected, groupselected 有值则有参数，0为默认全部，不需要传值
        if (this.planselected) {
          query = _.assignIn({
            planId: this.planselected
          }, query)
        }
        if (this.groupselected) {
          query = _.assignIn({
            groupId: this.groupselected
          }, query)
        }
        return query
      },
      reportName () {
        return `${_.find(this.tablist, {id: this.currentTab}).name}报表`
      },
      placeHolder () {
        if (this.currentTab === 'query__keyword__matchtype') {
          return '请输入关键词'
        } else if (this.currentTab === 'landpage__keyword') {
          return '请输入落地页URL'
        } else {
          return `请输入${_.find(this.tablist, {id: this.currentTab}).name}`
        }
      },
      reportApi () {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      },
      customColumns () {
        let columns = []
        switch (this.currentView) {
          case 'promotion':
            columns = [
              {
                title: '分析维度',
                fixed: true,
                children: [
                  {
                    title: '推广趋势',
                    key: 'name',
                    width: 300,
                    render: (index, value, item, type) => {
                      if (type === 'date') {
                        return value.split(' ')[0]
                      } else {
                        return this.textEllipsidRender(index, value, item)
                      }
                    }
                  }
                ]
              }
            ]
            break
          case 'query':
            columns = [
              {
                title: '分析维度',
                fixed: true,
                children: [
                  {
                    title: '搜索词',
                    key: 'query',
                    width: 220,
                    render: this.textEllipsidRender
                  }, {
                    title: '关键词',
                    key: 'keyword',
                    width: 120,
                    render: this.textEllipsidRender
                  }, {
                    title: '触发模式',
                    key: 'matchtype',
                    width: 100,
                    render: this.textEllipsidRender
                  }
                ]
              }
            ]
            break
          case 'landpage':
            columns = [
              {
                title: '分析维度',
                fixed: true,
                children: [
                  {
                    title: '落地页',
                    key: 'landpage',
                    width: 170,
                    render: this.textEllipsidRender
                  }, {
                    title: '关键词',
                    key: 'keyword',
                    width: 150,
                    render: this.textEllipsidRender
                  }
                ]
              }
            ]
            break
          default :
            break
        }
        const customColumns = this.getCustomColumns({hasSpread: true})
        if (this.currentTab === 'advert__plan__groupName') {
          columns[0].children = _.concat(columns[0].children, [
            {
              title: '推广计划',
              key: 'plan',
              render: this.textEllipsidRender
            }, {
              title: '推广组',
              key: 'groupName',
              render: this.textEllipsidRender
            }
          ])
        }
        if (this.currentTab === 'groupName__plan') {
          columns[0].children = _.concat(columns[0].children, [
            {
              title: '推广计划',
              key: 'plan',
              render: this.textEllipsidRender
            }
          ])
        }

        columns[0].children[0].title = _.find(this.tablist, {id: this.currentTab}).name

        columns[0].children[0].key = this.currentTab === 'product' && !this.compared ? 'date' :
          this.currentTab === 'groupName__plan' ? this.compared ? 'multiname' : 'groupName' :
          this.currentTab === 'advert__plan__groupName' ? this.compared ? 'multiname' : 'advert' : 'name'
        if (this.currentTab === 'query__keyword__matchtype') {
          columns[0].children[0].key = this.compared === false ? 'query' : 'multiname'
          columns[0].children[1].key = 'keyword'
          columns[0].children[2].key = 'matchtype'
        }
        if (this.currentTab === 'landpage__keyword') {
          columns[0].children[0].key = this.compared === false ? 'landpage' : 'multiname'
          columns[0].children[1].key = 'keyword'
        }

        const newColumns = this.getRecombineColumns(customColumns, this.tableIndices)
        return _.concat(columns, newColumns)
      }
    },
    mounted () {
      this.transelected = 'null'
      this.fetchTransList()
      this.getSiteDianjingIDs()
      this.getPlanList()
    },
    watch: {
      domainId () {
        this.transelected = 'null'
        this.clearKeyword()
        this.getSiteDianjingIDs()
        this.getTableData()
        this.checkDomainType()
        this.fetchTransList()
        this.getPlanList()
      },
      compared (newVal, oldVal) {
        this.compared = newVal
        this.resetIndice()
        if (newVal) {
          this.checkboxLength = 1
        } else {
          this.checkboxLength = 3
        }
      },
      uiError () {
        if (this.uiError.errMsg) {
          this.$Modal.warn(this.uiError.errMsg)
        }
      }
    },
    methods: {
      ...mapActions('web', {
        setTableIndices: 'SET_TABLE_INDICES'
      }),
      reddotObj (key) {
        if (key === 'promotion') {
          return {}
        } else {
          return {key: key, top: '10px', right: '6px'}
        }
      },
      // 重置compared并获取数据
      resetCompared () {
        this.compared = false
        this.chartResList = []
        this.clearKeyword()
        this.getTableData()
        this.getPlanList()
      },
      doSearch (keyword) {
        this.keyword = keyword
        this.getTableData()
      },
      transTypeName (key) {
        const transType = ['全部转化', '页面转化', '事件转化', '时长转化', '页数转化']
        return transType[key]
      },
      changeViewTo (comp) {
        const view = _.find(this.tabViews, { comp })
        if (view) {
          if (this.currentView !== view.comp) {
            this.currentView = view.comp
            this.currentTab = view.tablist[0].id
            this.tabChange()
          }
        }
      },
      fetchTransList () {
        if (!this.domainId) return
        const translistPromise = this.$http.get('/api/trans/list', {
          params: {
            ps: 100,
            pg: 1,
            cycle: 'hour',
            domainId: this.domainId,
            timespan: new Date().getTime()
          }
        })
        this.$store.dispatch('VUE_HTTP', [translistPromise])
          .then((res) => {
            if (res) {
              const transList = _.groupBy(_.get(res, 'list'), 'type')
              const newTransList = [
                {
                  label: '全部转化',
                  value: 'null'
                }
              ]
              // 根据v-select所需options的格式进行修改
              _.forIn(transList, (value, key) => {
                newTransList.push({
                  label: this.transTypeName(key),
                  options: value.map(item => {
                    return {
                      value: item.id,
                      label: String(item.name)
                    }
                  })
                })
              })
              this.transList = newTransList
            }
          })
      },
      onCustomIndiceChange (indices) {
        this.setTableIndices(indices)
      },
      // 由于不同view中tab会相同，额外做处理
      tabChange () {
        this.resetTab(this.currentTab)
        this.sdim = 'null'
        this.keyword = ''
        this.planselected = 0
        this.groupselected = 0
        this.order = _.find(this.tablist, {id: this.currentTab}).order
        this.isasc = 0
        this.resetIndice()
        if (this.currentTab === 'query__keyword__matchtype' || this.currentTab === 'landpage__keyword') {
          this.hasCheckBox = true
        } else {
          this.hasCheckBox = false
        }
        this.getTableData()
      },
      updateTab (tab) {
        if (this.currentTab === tab) return
        this.resetTab(tab)
        this.keyword = ''
        this.planselected = 0
        this.groupselected = 0
        this.resetIndice()
        if (this.currentTab === 'product') {
          this.hasCheckBox = false
        } else {
          this.hasCheckBox = true
        }
        this.getTableData()
      },
      getGroupList () {
        this.groupselected = 0
        this.clearKeyword()
        this.getTableData()
        const params = _.assignIn({}, _.pick(this.query,
          ['cycle', 'domainId', 'start', 'end', 'timespan']))
        if (this.planselected !== 0) {
          params.planId = this.planselected
        }
        const grouplistPromise = this.$http.get('/api/djad/grouplist', {
          params: params
        })
        let grouplist = []
        this.$store.dispatch('VUE_HTTP', [ grouplistPromise ])
          .then((res) => {
            if (res) {
              grouplist = _.concat([{id: 0, name: '全部推广组'}], res.list)
              this.grouplistOptions = _.uniqBy(grouplist, 'id').map(item => {
                return {
                  value: item.id,
                  label: item.name
                }
              })
            }
          })
      },
      getPlanList () {
        const planPromise = this.$http.get('/api/djad/planlist', {
          params: _.assignIn({}, _.pick(this.query,
            ['cycle', 'domainId', 'start', 'end', 'timespan']))
        })
        let planlist = []
        this.$store.dispatch('VUE_HTTP', [planPromise])
          .then((res) => {
            if (res) {
              planlist = _.concat([{id: 0, name: '全部推广计划'}], res.list)
              this.planlistOptions = _.uniqBy(planlist, 'id').map(item => {
                return {
                  value: item.id,
                  label: item.name
                }
              })
            }
          }).catch((e) => {
            console.log(e)
          })
      }
    },
    created () {
      this.setTableIndices(this.defaultCustomIndices)
    }
  }
</script>
<style scoped>
.search {
  float: right;
}
.right-tab a {
  float: left;
}
</style>



// WEBPACK FOOTER //
// promotion.vue?0cfdb41f